// components/common/LoadingSpinner.jsx
import styles from "./LoadingSpinner.module.css";

const LoadingSpinner = ({ size = "medium", className = "" }) => {
  return (
    <div className={`${styles.spinnerContainer} ${className}`}>
      <div className={`${styles.spinner} ${styles[size]}`}></div>
    </div>
  );
};

export default LoadingSpinner;
